import axios from 'axios'

export const ApiCalls = {
  getUrl () {
    return process.env.VUE_APP_API_URL
    // return '10.51.133.135:8080'
  },
  getSystem () {
    return 'EVM'
  },
  getENM () {
    return 'ENM'
  },
  createConfig: function () {
    return {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,POST,DELETE,PUT,OPTIONS',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Credentials': true,
        'Access-Control-Max-Age': 180,
        'Content-Type': 'application/json'
      }
    }
  },
  getCustomerPayment (custNo) {
    let url = this.getUrl() + '/customer/getCustomer'

    let payload = JSON.stringify({
      cust_no: custNo,
      company: this.getSystem()
    })
    return this.runCall(url, payload)
  },
  checkCustomerPayment (custNo) {
    let url = this.getUrl() + '/customer/checkCustomer'

    let payload = JSON.stringify({
      cust_no: custNo,
      company: this.getSystem()
    })
    return this.runCall(url, payload)
  },
  login (custNo) {
    let url = this.getUrl() + '/login'

    let payload = JSON.stringify({
      custNo: custNo,
      company: this.getSystem()
    })
    return this.runRawCall(url, payload)
  },
  startPayment (custNo, paymentMethod, amount, priority) {
    let url = this.getUrl() + '/customer/startPayment'

    let payload = JSON.stringify({
      cust_no: custNo,
      paymentMethod: paymentMethod,
      company: this.getSystem(),
      amount: amount,
      priority: priority
    })
    return this.runCall(url, payload)
  },
  startPayPalPayment (custNo, paymentMethod, amount, mail, priority) {
    let url = this.getUrl() + '/customer/startPayment'

    let payload = JSON.stringify({
      cust_no: custNo,
      paymentMethod: paymentMethod,
      company: this.getSystem(),
      amount: amount,
      mail: mail,
      priority: priority
    })
    return this.runCall(url, payload)
  },
  startPayment4Barzahlen (custNo, paymentMethod, contactMethod, contact, amount, priority) {
    let url = this.getUrl() + '/customer/startPayment'

    let payload = JSON.stringify({
      cust_no: custNo,
      paymentMethod: paymentMethod,
      company: this.getSystem(),
      contactType: contactMethod,
      contact: contact,
      amount: amount,
      priority: priority
    })
    return this.runCall(url, payload)
  },
  processCallback (orderId, merchantref, paymentmethod, pi, status) {
    let url = this.getUrl() + '/customer/processCallback'

    let payload = JSON.stringify({
      orderId: orderId,
      merchantref: merchantref,
      paymentmethod: paymentmethod,
      pi: pi,
      company: this.getSystem(),
      status: status
    })
    return this.runCall(url, payload)
  },
  // ---------------------------------------------------------- Standrohr ---------------------------------------------------
  loadSpecialCustomer (communalno) {
    let url = this.getUrl() + '/standpipe/loadSpecialCustomer'

    let payload = JSON.stringify({
      specialKey: communalno
    })
    return this.runCall(url, payload)
  },
  safeFirstForm (customerId, selectedCustType, communalno, name1, name2,
    contact, street, houseNo, zip, city, mail, fon) {
    let url = this.getUrl() + '/standpipe/saveFirstForm'

    let payload = JSON.stringify({

      customerId: customerId,
      selectedCustType: selectedCustType,
      communalno: communalno,
      name1: name1,
      name2: name2,
      contact: contact,
      street: street,
      houseNo: houseNo,
      zip: zip,
      city: city,
      mail: mail,
      fon: fon,
      company: this.getENM()
    })
    return this.runCall(url, payload)
  },
  safeSecondForm (customerId, street, houseNo, zip,
    city, selectedConnection, selectedUseCase, useUntil) {
    let url = this.getUrl() + '/standpipe/saveSecondForm'

    let payload = JSON.stringify({
      customerId: customerId,
      useStreet: street,
      useHouseNo: houseNo,
      useZip: zip,
      useCity: city,
      connectionType: selectedConnection,
      useCase: selectedUseCase,
      useUntil: useUntil,
      company: this.getENM()
    })
    return this.runCall(url, payload)
  },
  safeThirdForm (customerId, iban, bic, bank, paymentMethod, contactType, contact) {
    let url = this.getUrl() + '/standpipe/saveThirdForm'

    let payload = JSON.stringify({
      customerId: customerId,
      iban: iban,
      bic: bic,
      bank: bank,
      paymentMethod: paymentMethod,
      contactType: contactType,
      contact: contact,
      company: this.getENM()
    })
    return this.runCall(url, payload)
  },
  // ---------------------------------------------------------- CALLS ---------------------------------------------------
  runCall (url, payload) {
    let config = this.createConfig()
    return new Promise((resolve, reject) => {
      axios.post(url, payload, config)
        .then(res => {
          resolve(res.data)
        }).catch(function (err) {
          console.log('', err)
          reject(err)
        })
    })
  },
  runRawCall (url, payload) {
    let config = this.createConfig()
    return new Promise((resolve, reject) => {
      axios.post(url, payload, config)
        .then(res => {
          resolve(res)
        }).catch(function (err) {
          console.log('', err)
          reject(err)
        })
    })
  }
}
